import { Pipe, NgModule } from '@angular/core';
import { __spread, __read, __extends } from 'tslib';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var DiffPipe = /** @class */ (function () {
    function DiffPipe() {
    }
    /**
     * @param {?} input
     * @param {...?} args
     * @return {?}
     */
    DiffPipe.prototype.transform = /**
     * @param {?} input
     * @param {...?} args
     * @return {?}
     */
    function (input) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (!Array.isArray(input)) {
            return input;
        }
        // tslint:disable-next-line no-bitwise
        return args.reduce(function (d, c) { return d.filter(function (e) { return !~c.indexOf(e); }); }, input);
    };
    DiffPipe.decorators = [
        { type: Pipe, args: [{ name: "diff" },] },
    ];
    return DiffPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var InitialPipe = /** @class */ (function () {
    function InitialPipe() {
    }
    /**
     * @param {?} input
     * @param {?=} num
     * @return {?}
     */
    InitialPipe.prototype.transform = /**
     * @param {?} input
     * @param {?=} num
     * @return {?}
     */
    function (input, num) {
        if (num === void 0) { num = 0; }
        return Array.isArray(input) ? input.slice(0, input.length - num) : input;
    };
    InitialPipe.decorators = [
        { type: Pipe, args: [{ name: "initial" },] },
    ];
    return InitialPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var FlattenPipe = /** @class */ (function () {
    function FlattenPipe() {
    }
    /**
     * @param {?} input
     * @param {?=} shallow
     * @return {?}
     */
    FlattenPipe.prototype.transform = /**
     * @param {?} input
     * @param {?=} shallow
     * @return {?}
     */
    function (input, shallow) {
        if (shallow === void 0) { shallow = false; }
        if (!Array.isArray(input)) {
            return input;
        }
        return shallow ? [].concat.apply([], input) : this.flatten(input);
    };
    /**
     * @param {?} array
     * @return {?}
     */
    FlattenPipe.prototype.flatten = /**
     * @param {?} array
     * @return {?}
     */
    function (array) {
        var _this = this;
        return array.reduce(function (arr, elm) {
            if (Array.isArray(elm)) {
                return arr.concat(_this.flatten(elm));
            }
            return arr.concat(elm);
        }, []);
    };
    FlattenPipe.decorators = [
        { type: Pipe, args: [{ name: "flatten" },] },
    ];
    return FlattenPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var IntersectionPipe = /** @class */ (function () {
    function IntersectionPipe() {
    }
    /**
     * @param {?} input
     * @param {...?} args
     * @return {?}
     */
    IntersectionPipe.prototype.transform = /**
     * @param {?} input
     * @param {...?} args
     * @return {?}
     */
    function (input) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (!Array.isArray(input)) {
            return input;
        }
        // tslint:disable-next-line no-bitwise
        return args.reduce(function (n, c) { return n.filter(function (e) { return !!~c.indexOf(e); }); }, input);
    };
    IntersectionPipe.decorators = [
        { type: Pipe, args: [{ name: "intersection" },] },
    ];
    return IntersectionPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @param {?} value
 * @return {?}
 */
function isUndefined(value) {
    return typeof value === "undefined";
}
/**
 * @param {?} value
 * @return {?}
 */
function isFunction(value) {
    return typeof value === "function";
}
/**
 * @param {?} value
 * @return {?}
 */
function isNumber(value) {
    return typeof value === "number";
}
/**
 * @param {?} value
 * @return {?}
 */
function isString(value) {
    return typeof value === "string";
}
/**
 * @param {?} value
 * @return {?}
 */
function isBoolean(value) {
    return typeof value === "boolean";
}
/**
 * @param {?} value
 * @return {?}
 */
function isObject(value) {
    return value !== null && typeof value === "object";
}
/**
 * @param {?} value
 * @return {?}
 */
function isNumberFinite(value) {
    return isNumber(value) && isFinite(value);
}
/**
 * @param {?} num
 * @param {?} precision
 * @return {?}
 */
function applyPrecision(num, precision) {
    if (precision <= 0) {
        return Math.round(num);
    }
    var /** @type {?} */ tho = Math.pow(10, precision);
    return Math.round(num * tho) / tho;
}
/**
 * @param {?} obj
 * @param {?} map
 * @return {?}
 */
function extractDeepPropertyByMapKey(obj, map) {
    var /** @type {?} */ keys = map.split(".");
    var /** @type {?} */ head = keys.shift();
    return keys.reduce(function (prop, key) {
        return !isUndefined(prop) && !isUndefined(prop[key]) ? prop[key] : undefined;
    }, obj[head || ""]);
}
/**
 * @param {?} obj
 * @param {?} map
 * @return {?}
 */
function extractDeepPropertyByParentMapKey(obj, map) {
    var /** @type {?} */ keys = map.split(".");
    var /** @type {?} */ tail = keys.pop();
    var /** @type {?} */ props = extractDeepPropertyByMapKey(obj, keys.join("."));
    return { props: props, tail: tail };
}
/**
 * @param {?} obj
 * @param {?} other
 * @return {?}
 */
function getKeysTwoObjects(obj, other) {
    return __spread(Object.keys(obj), Object.keys(other)).filter(function (key, index, array) { return array.indexOf(key) === index; });
}
/**
 * @param {?} obj
 * @param {?} other
 * @return {?}
 */
function isDeepEqual(obj, other) {
    if (!isObject(obj) || !isObject(other)) {
        return obj === other;
    }
    return getKeysTwoObjects(obj, other).every(function (key) {
        if (!isObject(obj[key]) && !isObject(other[key])) {
            return obj[key] === other[key];
        }
        if (!isObject(obj[key]) || !isObject(other[key])) {
            return false;
        }
        return isDeepEqual(obj[key], other[key]);
    });
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var ReversePipe = /** @class */ (function () {
    function ReversePipe() {
    }
    /**
     * @param {?} input
     * @return {?}
     */
    ReversePipe.prototype.transform = /**
     * @param {?} input
     * @return {?}
     */
    function (input) {
        if (isString(input)) {
            return input
                .split("")
                .reverse()
                .join("");
        }
        return Array.isArray(input) ? input.slice().reverse() : input;
    };
    ReversePipe.decorators = [
        { type: Pipe, args: [{ name: "reverse" },] },
    ];
    return ReversePipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var TailPipe = /** @class */ (function () {
    function TailPipe() {
    }
    /**
     * @param {?} input
     * @param {?=} num
     * @return {?}
     */
    TailPipe.prototype.transform = /**
     * @param {?} input
     * @param {?=} num
     * @return {?}
     */
    function (input, num) {
        if (num === void 0) { num = 0; }
        return Array.isArray(input) ? input.slice(num) : input;
    };
    TailPipe.decorators = [
        { type: Pipe, args: [{ name: "tail" },] },
    ];
    return TailPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var TrurthifyPipe = /** @class */ (function () {
    function TrurthifyPipe() {
    }
    /**
     * @param {?} input
     * @return {?}
     */
    TrurthifyPipe.prototype.transform = /**
     * @param {?} input
     * @return {?}
     */
    function (input) {
        return Array.isArray(input) ? input.filter(function (e) { return !!e; }) : input;
    };
    TrurthifyPipe.decorators = [
        { type: Pipe, args: [{ name: "truthify" },] },
    ];
    return TrurthifyPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var UnionPipe = /** @class */ (function () {
    function UnionPipe() {
    }
    /**
     * @param {?} input
     * @param {?=} args
     * @return {?}
     */
    UnionPipe.prototype.transform = /**
     * @param {?} input
     * @param {?=} args
     * @return {?}
     */
    function (input, args) {
        if (args === void 0) { args = []; }
        if (!Array.isArray(input) || !Array.isArray(args)) {
            return input;
        }
        return args.reduce(function (newArr, currArr) {
            return newArr.concat(currArr.reduce(function (noDupArr, curr) {
                // tslint:disable-next-line:no-bitwise
                return !~noDupArr.indexOf(curr) && !~newArr.indexOf(curr) ? noDupArr.concat([curr]) : noDupArr;
            }, []));
        }, input);
    };
    UnionPipe.decorators = [
        { type: Pipe, args: [{ name: "union" },] },
    ];
    return UnionPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var UniquePipe = /** @class */ (function () {
    function UniquePipe() {
    }
    /**
     * @param {?} input
     * @param {?=} propertyName
     * @return {?}
     */
    UniquePipe.prototype.transform = /**
     * @param {?} input
     * @param {?=} propertyName
     * @return {?}
     */
    function (input, propertyName) {
        var /** @type {?} */ uniques = [];
        return Array.isArray(input)
            ? isUndefined(propertyName)
                ? input.filter(function (e, i) { return input.indexOf(e) === i; })
                : input.filter(function (e, i) {
                    var /** @type {?} */ value = extractDeepPropertyByMapKey(e, propertyName);
                    value = isObject(value) ? JSON.stringify(value) : value;
                    if (isUndefined(value) || uniques[value]) {
                        return false;
                    }
                    uniques[value] = true;
                    return true;
                })
            : input;
    };
    UniquePipe.decorators = [
        { type: Pipe, args: [{ name: "unique" },] },
    ];
    return UniquePipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var WithoutPipe = /** @class */ (function () {
    function WithoutPipe() {
    }
    /**
     * @param {?} input
     * @param {?=} args
     * @return {?}
     */
    WithoutPipe.prototype.transform = /**
     * @param {?} input
     * @param {?=} args
     * @return {?}
     */
    function (input, args) {
        if (args === void 0) { args = []; }
        return Array.isArray(input)
            ? // tslint:disable-next-line:no-bitwise
                input.filter(function (e) { return !~args.indexOf(e); })
            : input;
    };
    WithoutPipe.decorators = [
        { type: Pipe, args: [{ name: "without" },] },
    ];
    return WithoutPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var PluckPipe = /** @class */ (function () {
    function PluckPipe() {
    }
    /**
     * @param {?} input
     * @param {?} map
     * @return {?}
     */
    PluckPipe.prototype.transform = /**
     * @param {?} input
     * @param {?} map
     * @return {?}
     */
    function (input, map) {
        return Array.isArray(input) ? input.map(function (e) { return extractDeepPropertyByMapKey(e, map); }) : input;
    };
    PluckPipe.decorators = [
        { type: Pipe, args: [{ name: "pluck", pure: false },] },
    ];
    return PluckPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var ShufflePipe = /** @class */ (function () {
    function ShufflePipe() {
    }
    // Using a version of the Fisher-Yates shuffle algorithm
    // https://en.wikipedia.org/wiki/Fisher%E2%80%93Yates_shuffle
    /**
     * @param {?} input
     * @return {?}
     */
    ShufflePipe.prototype.transform = /**
     * @param {?} input
     * @return {?}
     */
    function (input) {
        if (!Array.isArray(input)) {
            return input;
        }
        var /** @type {?} */ shuffled = __spread(input);
        var /** @type {?} */ n = input.length - 1;
        for (var /** @type {?} */ i = 0; i < n; ++i) {
            var /** @type {?} */ j = Math.floor(Math.random() * (n - i + 1)) + i;
            _a = __read([shuffled[j], shuffled[i]], 2), shuffled[i] = _a[0], shuffled[j] = _a[1];
        }
        return shuffled;
        var _a;
    };
    ShufflePipe.decorators = [
        { type: Pipe, args: [{ name: "shuffle" },] },
    ];
    return ShufflePipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var EveryPipe = /** @class */ (function () {
    function EveryPipe() {
    }
    /**
     * @param {?} input
     * @param {?} predicate
     * @return {?}
     */
    EveryPipe.prototype.transform = /**
     * @param {?} input
     * @param {?} predicate
     * @return {?}
     */
    function (input, predicate) {
        return Array.isArray(input) ? input.every(predicate) : false;
    };
    EveryPipe.decorators = [
        { type: Pipe, args: [{ name: "every" },] },
    ];
    return EveryPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var SomePipe = /** @class */ (function () {
    function SomePipe() {
    }
    /**
     * @param {?} input
     * @param {?} predicate
     * @return {?}
     */
    SomePipe.prototype.transform = /**
     * @param {?} input
     * @param {?} predicate
     * @return {?}
     */
    function (input, predicate) {
        return Array.isArray(input) ? input.some(predicate) : input;
    };
    SomePipe.decorators = [
        { type: Pipe, args: [{ name: "some" },] },
    ];
    return SomePipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var SamplePipe = /** @class */ (function () {
    function SamplePipe() {
    }
    /**
     * @param {?} input
     * @param {?=} len
     * @return {?}
     */
    SamplePipe.prototype.transform = /**
     * @param {?} input
     * @param {?=} len
     * @return {?}
     */
    function (input, len) {
        if (len === void 0) { len = 1; }
        if (!Array.isArray(input)) {
            return input;
        }
        var /** @type {?} */ sample = [];
        var /** @type {?} */ tmp = __spread(input);
        var /** @type {?} */ l = len < tmp.length ? len : tmp.length;
        for (var /** @type {?} */ i = 0; i < l; ++i) {
            sample = sample.concat(tmp.splice(Math.floor(Math.random() * tmp.length), 1));
        }
        return sample;
    };
    SamplePipe.decorators = [
        { type: Pipe, args: [{ name: "sample" },] },
    ];
    return SamplePipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var GroupByPipe = /** @class */ (function () {
    function GroupByPipe() {
    }
    /**
     * @param {?} input
     * @param {?=} discriminator
     * @param {?=} delimiter
     * @return {?}
     */
    GroupByPipe.prototype.transform = /**
     * @param {?} input
     * @param {?=} discriminator
     * @param {?=} delimiter
     * @return {?}
     */
    function (input, discriminator, delimiter) {
        if (discriminator === void 0) { discriminator = []; }
        if (delimiter === void 0) { delimiter = "|"; }
        if (!Array.isArray(input)) {
            return input;
        }
        return this.groupBy(input, discriminator, delimiter);
    };
    /**
     * @param {?} list
     * @param {?} discriminator
     * @param {?} delimiter
     * @return {?}
     */
    GroupByPipe.prototype.groupBy = /**
     * @param {?} list
     * @param {?} discriminator
     * @param {?} delimiter
     * @return {?}
     */
    function (list, discriminator, delimiter) {
        var _this = this;
        return list.reduce(function (acc, payload) {
            var /** @type {?} */ key = _this.extractKeyByDiscriminator(discriminator, payload, delimiter);
            acc[key] = Array.isArray(acc[key]) ? acc[key].concat([payload]) : [payload];
            return acc;
        }, {});
    };
    /**
     * @param {?} discriminator
     * @param {?} payload
     * @param {?} delimiter
     * @return {?}
     */
    GroupByPipe.prototype.extractKeyByDiscriminator = /**
     * @param {?} discriminator
     * @param {?} payload
     * @param {?} delimiter
     * @return {?}
     */
    function (discriminator, payload, delimiter) {
        if (isFunction(discriminator)) {
            return (/** @type {?} */ (discriminator))(payload);
        }
        if (Array.isArray(discriminator)) {
            return discriminator.map(function (k) { return extractDeepPropertyByMapKey(payload, k); }).join(delimiter);
        }
        return extractDeepPropertyByMapKey(payload, /** @type {?} */ (discriminator));
    };
    GroupByPipe.decorators = [
        { type: Pipe, args: [{ name: "groupBy" },] },
    ];
    return GroupByPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var FilterByPipe = /** @class */ (function () {
    function FilterByPipe() {
    }
    /**
     * @param {?} input
     * @param {?} props
     * @param {?=} search
     * @param {?=} strict
     * @return {?}
     */
    FilterByPipe.prototype.transform = /**
     * @param {?} input
     * @param {?} props
     * @param {?=} search
     * @param {?=} strict
     * @return {?}
     */
    function (input, props, search, strict) {
        if (search === void 0) { search = ""; }
        if (strict === void 0) { strict = false; }
        if (!Array.isArray(input) || (!isString(search) && !isNumberFinite(search) && !isBoolean(search))) {
            return input;
        }
        var /** @type {?} */ term = String(search).toLowerCase();
        return input.filter(function (obj) {
            return props.some(function (prop) {
                var /** @type {?} */ value = extractDeepPropertyByMapKey(obj, prop);
                var _a = extractDeepPropertyByParentMapKey(obj, prop), props = _a.props, tail = _a.tail;
                if (isUndefined(value) && !isUndefined(props) && Array.isArray(props)) {
                    return props.some(function (parent) {
                        var /** @type {?} */ str = String(parent[tail]).toLowerCase();
                        return strict ? str === term : !!~str.indexOf(term);
                    });
                }
                if (isUndefined(value)) {
                    return false;
                }
                var /** @type {?} */ strValue = String(value).toLowerCase();
                return strict ? term === strValue : !!~strValue.indexOf(term);
            });
        });
    };
    FilterByPipe.decorators = [
        { type: Pipe, args: [{ name: "filterBy" },] },
    ];
    return FilterByPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var OrderByPipe = /** @class */ (function () {
    function OrderByPipe() {
    }
    /**
     * @param {?} input
     * @param {?=} config
     * @return {?}
     */
    OrderByPipe.prototype.transform = /**
     * @param {?} input
     * @param {?=} config
     * @return {?}
     */
    function (input, config) {
        if (!Array.isArray(input)) {
            return input;
        }
        var /** @type {?} */ out = __spread(input);
        // sort by multiple properties
        if (Array.isArray(config)) {
            return out.sort(function (a, b) {
                var /** @type {?} */ l = config.length;
                for (var /** @type {?} */ i = 0; i < l; ++i) {
                    var _a = __read(OrderByPipe.extractFromConfig(config[i]), 2), prop = _a[0], asc = _a[1];
                    var /** @type {?} */ pos = OrderByPipe.orderCompare(prop, asc, a, b);
                    if (pos !== 0) {
                        return pos;
                    }
                }
                return 0;
            });
        }
        // sort by a single property value
        if (isString(config)) {
            var _a = __read(OrderByPipe.extractFromConfig(config), 3), prop = _a[0], asc = _a[1], sign = _a[2];
            if (config.length === 1) {
                // tslint:disable-next-line:switch-default
                switch (sign) {
                    case "+":
                        return out.sort(OrderByPipe.simpleSort.bind(this));
                    case "-":
                        return out.sort(OrderByPipe.simpleSort.bind(this)).reverse();
                }
            }
            return out.sort(OrderByPipe.orderCompare.bind(this, prop, asc));
        }
        // default sort by value
        return out.sort(OrderByPipe.simpleSort.bind(this));
    };
    /**
     * @param {?} a
     * @param {?} b
     * @return {?}
     */
    OrderByPipe.simpleSort = /**
     * @param {?} a
     * @param {?} b
     * @return {?}
     */
    function (a, b) {
        return isString(a) && isString(b) ? a.toLowerCase().localeCompare(b.toLowerCase()) : a - b;
    };
    /**
     * @param {?} prop
     * @param {?} asc
     * @param {?} a
     * @param {?} b
     * @return {?}
     */
    OrderByPipe.orderCompare = /**
     * @param {?} prop
     * @param {?} asc
     * @param {?} a
     * @param {?} b
     * @return {?}
     */
    function (prop, asc, a, b) {
        var /** @type {?} */ first = extractDeepPropertyByMapKey(a, prop);
        var /** @type {?} */ second = extractDeepPropertyByMapKey(b, prop);
        if (first === second) {
            return 0;
        }
        if (isUndefined(first) || first === "") {
            return 1;
        }
        if (isUndefined(second) || second === "") {
            return -1;
        }
        if (isString(first) && isString(second)) {
            var /** @type {?} */ pos = first.toLowerCase().localeCompare(second.toLowerCase());
            return asc ? pos : -pos;
        }
        return asc ? first - second : second - first;
    };
    /**
     * @param {?} config
     * @return {?}
     */
    OrderByPipe.extractFromConfig = /**
     * @param {?} config
     * @return {?}
     */
    function (config) {
        var /** @type {?} */ sign = config.substr(0, 1);
        var /** @type {?} */ prop = config.replace(/^[-+]/, "");
        var /** @type {?} */ asc = sign !== "-";
        return [prop, asc, sign];
    };
    OrderByPipe.decorators = [
        { type: Pipe, args: [{ name: "orderBy" },] },
    ];
    return OrderByPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var GroupByImpurePipe = /** @class */ (function (_super) {
    __extends(GroupByImpurePipe, _super);
    function GroupByImpurePipe() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GroupByImpurePipe.decorators = [
        { type: Pipe, args: [{ name: "groupByImpure", pure: false },] },
    ];
    return GroupByImpurePipe;
}(GroupByPipe));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var FilterByImpurePipe = /** @class */ (function (_super) {
    __extends(FilterByImpurePipe, _super);
    function FilterByImpurePipe() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FilterByImpurePipe.decorators = [
        { type: Pipe, args: [{ name: "filterByImpure", pure: false },] },
    ];
    return FilterByImpurePipe;
}(FilterByPipe));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var OrderByImpurePipe = /** @class */ (function (_super) {
    __extends(OrderByImpurePipe, _super);
    function OrderByImpurePipe() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OrderByImpurePipe.decorators = [
        { type: Pipe, args: [{ name: "orderByImpure", pure: false },] },
    ];
    return OrderByImpurePipe;
}(OrderByPipe));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var RangePipe = /** @class */ (function () {
    function RangePipe() {
    }
    /**
     * @param {?=} start
     * @param {?=} count
     * @param {?=} step
     * @return {?}
     */
    RangePipe.prototype.transform = /**
     * @param {?=} start
     * @param {?=} count
     * @param {?=} step
     * @return {?}
     */
    function (start, count, step) {
        if (start === void 0) { start = 1; }
        if (count === void 0) { count = 0; }
        if (step === void 0) { step = 1; }
        return Array(count)
            .fill("")
            .map(function (v, i) { return step * i + start; });
    };
    RangePipe.decorators = [
        { type: Pipe, args: [{ name: "range" },] },
    ];
    return RangePipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var /** @type {?} */ ARRAY_PIPES = [
    DiffPipe,
    FlattenPipe,
    InitialPipe,
    IntersectionPipe,
    ReversePipe,
    TailPipe,
    TrurthifyPipe,
    UnionPipe,
    UniquePipe,
    WithoutPipe,
    PluckPipe,
    ShufflePipe,
    EveryPipe,
    SomePipe,
    SamplePipe,
    GroupByPipe,
    GroupByImpurePipe,
    FilterByPipe,
    FilterByImpurePipe,
    OrderByPipe,
    OrderByImpurePipe,
    RangePipe,
];
var NgArrayPipesModule = /** @class */ (function () {
    function NgArrayPipesModule() {
    }
    NgArrayPipesModule.decorators = [
        { type: NgModule, args: [{
                    declarations: ARRAY_PIPES,
                    imports: [],
                    exports: ARRAY_PIPES,
                },] },
    ];
    return NgArrayPipesModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var KeysPipe = /** @class */ (function () {
    function KeysPipe() {
    }
    /**
     * @param {?} obj
     * @return {?}
     */
    KeysPipe.prototype.transform = /**
     * @param {?} obj
     * @return {?}
     */
    function (obj) {
        if (Array.isArray(obj) || !isObject(obj)) {
            return obj;
        }
        return Object.keys(obj);
    };
    KeysPipe.decorators = [
        { type: Pipe, args: [{ name: "keys" },] },
    ];
    return KeysPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var ValuesPipe = /** @class */ (function () {
    function ValuesPipe() {
    }
    /**
     * @param {?} obj
     * @return {?}
     */
    ValuesPipe.prototype.transform = /**
     * @param {?} obj
     * @return {?}
     */
    function (obj) {
        if (Array.isArray(obj) || !isObject(obj)) {
            return obj;
        }
        return Object.keys(obj).map(function (k) { return obj[k]; });
    };
    ValuesPipe.decorators = [
        { type: Pipe, args: [{ name: "values" },] },
    ];
    return ValuesPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var PairsPipe = /** @class */ (function () {
    function PairsPipe() {
    }
    /**
     * @param {?} obj
     * @return {?}
     */
    PairsPipe.prototype.transform = /**
     * @param {?} obj
     * @return {?}
     */
    function (obj) {
        if (Array.isArray(obj) || !isObject(obj)) {
            return obj;
        }
        return Object.keys(obj).map(function (k) { return [k, obj[k]]; });
    };
    PairsPipe.decorators = [
        { type: Pipe, args: [{ name: "pairs" },] },
    ];
    return PairsPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var PickPipe = /** @class */ (function () {
    function PickPipe() {
    }
    /**
     * @param {?} obj
     * @param {...?} args
     * @return {?}
     */
    PickPipe.prototype.transform = /**
     * @param {?} obj
     * @param {...?} args
     * @return {?}
     */
    function (obj) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (Array.isArray(obj) || !isObject(obj)) {
            return obj;
        }
        return args.reduce(function (o, k) {
            return Object.assign(o, (_a = {}, _a[k] = obj[k], _a));
            var _a;
        }, {});
    };
    PickPipe.decorators = [
        { type: Pipe, args: [{ name: "pick" },] },
    ];
    return PickPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var OmitPipe = /** @class */ (function () {
    function OmitPipe() {
    }
    /**
     * @param {?} obj
     * @param {...?} args
     * @return {?}
     */
    OmitPipe.prototype.transform = /**
     * @param {?} obj
     * @param {...?} args
     * @return {?}
     */
    function (obj) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (Array.isArray(obj) || !isObject(obj)) {
            return obj;
        }
        return (Object.keys(obj)
            .filter(function (k) { return !~args.indexOf(k); })
            .reduce(function (o, k) {
            return Object.assign(o, (_a = {}, _a[k] = obj[k], _a));
            var _a;
        }, {}));
    };
    OmitPipe.decorators = [
        { type: Pipe, args: [{ name: "omit" },] },
    ];
    return OmitPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var InvertPipe = /** @class */ (function () {
    function InvertPipe() {
    }
    /**
     * @param {?} obj
     * @return {?}
     */
    InvertPipe.prototype.transform = /**
     * @param {?} obj
     * @return {?}
     */
    function (obj) {
        if (Array.isArray(obj) || !isObject(obj)) {
            return obj;
        }
        return Object.keys(obj).reduce(function (o, k) {
            return Object.assign(o, (_a = {}, _a[obj[k]] = k, _a));
            var _a;
        }, {});
    };
    InvertPipe.decorators = [
        { type: Pipe, args: [{ name: "invert" },] },
    ];
    return InvertPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var InvertByPipe = /** @class */ (function () {
    function InvertByPipe() {
    }
    /**
     * @param {?} obj
     * @param {?=} cb
     * @return {?}
     */
    InvertByPipe.prototype.transform = /**
     * @param {?} obj
     * @param {?=} cb
     * @return {?}
     */
    function (obj, cb) {
        if (Array.isArray(obj) || !isObject(obj)) {
            return obj;
        }
        return Object.keys(obj).reduce(function (o, k) {
            var /** @type {?} */ key = cb ? cb(obj[k]) : obj[k];
            return Array.isArray(o[key]) ? (o[key].push(k), o) : Object.assign(o, (_a = {}, _a[key] = [k], _a));
            var _a;
        }, {});
    };
    InvertByPipe.decorators = [
        { type: Pipe, args: [{ name: "invertBy" },] },
    ];
    return InvertByPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var DiffObjPipe = /** @class */ (function () {
    function DiffObjPipe() {
    }
    /**
     * @param {?} obj
     * @param {?=} original
     * @return {?}
     */
    DiffObjPipe.prototype.transform = /**
     * @param {?} obj
     * @param {?=} original
     * @return {?}
     */
    function (obj, original) {
        if (original === void 0) { original = {}; }
        if (Array.isArray(obj) || Array.isArray(original) || !isObject(obj) || !isObject(original)) {
            return {};
        }
        return getKeysTwoObjects(obj, original).reduce(function (diff, key) {
            if (!isDeepEqual(original[key], obj[key])) {
                diff[key] = obj[key];
            }
            return diff;
        }, {});
    };
    DiffObjPipe.decorators = [
        { type: Pipe, args: [{ name: "diffObj" },] },
    ];
    return DiffObjPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var /** @type {?} */ OBJECT_PIPES = [KeysPipe, ValuesPipe, PairsPipe, PickPipe, InvertPipe, InvertByPipe, OmitPipe, DiffObjPipe];
var NgObjectPipesModule = /** @class */ (function () {
    function NgObjectPipesModule() {
    }
    NgObjectPipesModule.decorators = [
        { type: NgModule, args: [{
                    declarations: OBJECT_PIPES,
                    imports: [],
                    exports: OBJECT_PIPES,
                },] },
    ];
    return NgObjectPipesModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var UcWordsPipe = /** @class */ (function () {
    function UcWordsPipe() {
    }
    /**
     * @param {?} text
     * @return {?}
     */
    UcWordsPipe.prototype.transform = /**
     * @param {?} text
     * @return {?}
     */
    function (text) {
        if (isString(text)) {
            return text
                .split(" ")
                .map(function (sub) { return sub.slice(0, 1).toUpperCase() + sub.slice(1); })
                .join(" ");
        }
        return text;
    };
    UcWordsPipe.decorators = [
        { type: Pipe, args: [{ name: "ucwords" },] },
    ];
    return UcWordsPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var LeftTrimPipe = /** @class */ (function () {
    function LeftTrimPipe() {
    }
    /**
     * @param {?} text
     * @param {?=} chars
     * @return {?}
     */
    LeftTrimPipe.prototype.transform = /**
     * @param {?} text
     * @param {?=} chars
     * @return {?}
     */
    function (text, chars) {
        if (chars === void 0) { chars = "\\s"; }
        return isString(text) ? text.replace(new RegExp("^[" + chars + "]+"), "") : text;
    };
    LeftTrimPipe.decorators = [
        { type: Pipe, args: [{ name: "ltrim" },] },
    ];
    return LeftTrimPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var RepeatPipe = /** @class */ (function () {
    function RepeatPipe() {
    }
    /**
     * @param {?} str
     * @param {?=} n
     * @param {?=} separator
     * @return {?}
     */
    RepeatPipe.prototype.transform = /**
     * @param {?} str
     * @param {?=} n
     * @param {?=} separator
     * @return {?}
     */
    function (str, n, separator) {
        if (n === void 0) { n = 1; }
        if (separator === void 0) { separator = ""; }
        if (n <= 0) {
            throw new RangeError();
        }
        return n === 1 ? str : this.repeat(str, n - 1, separator);
    };
    /**
     * @param {?} str
     * @param {?} n
     * @param {?} separator
     * @return {?}
     */
    RepeatPipe.prototype.repeat = /**
     * @param {?} str
     * @param {?} n
     * @param {?} separator
     * @return {?}
     */
    function (str, n, separator) {
        return isString(str) ? (n === 0 ? str : str + separator + this.repeat(str, n - 1, separator)) : str;
    };
    RepeatPipe.decorators = [
        { type: Pipe, args: [{ name: "repeat" },] },
    ];
    return RepeatPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var RightTrimPipe = /** @class */ (function () {
    function RightTrimPipe() {
    }
    /**
     * @param {?} text
     * @param {?=} chars
     * @return {?}
     */
    RightTrimPipe.prototype.transform = /**
     * @param {?} text
     * @param {?=} chars
     * @return {?}
     */
    function (text, chars) {
        if (chars === void 0) { chars = "\\s"; }
        return isString(text) ? text.replace(new RegExp("[" + chars + "]+$"), "") : text;
    };
    RightTrimPipe.decorators = [
        { type: Pipe, args: [{ name: "rtrim" },] },
    ];
    return RightTrimPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var ScanPipe = /** @class */ (function () {
    function ScanPipe() {
    }
    /**
     * @param {?} text
     * @param {?=} args
     * @return {?}
     */
    ScanPipe.prototype.transform = /**
     * @param {?} text
     * @param {?=} args
     * @return {?}
     */
    function (text, args) {
        if (args === void 0) { args = []; }
        return isString(text)
            ? text.replace(/\{(\d+)}/g, function (match, index) { return (!isUndefined(args[index]) ? args[index] : match); })
            : text;
    };
    ScanPipe.decorators = [
        { type: Pipe, args: [{ name: "scan" },] },
    ];
    return ScanPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var ShortenPipe = /** @class */ (function () {
    function ShortenPipe() {
    }
    /**
     * @param {?} text
     * @param {?=} length
     * @param {?=} suffix
     * @param {?=} wordBreak
     * @return {?}
     */
    ShortenPipe.prototype.transform = /**
     * @param {?} text
     * @param {?=} length
     * @param {?=} suffix
     * @param {?=} wordBreak
     * @return {?}
     */
    function (text, length, suffix, wordBreak) {
        if (length === void 0) { length = 0; }
        if (suffix === void 0) { suffix = ""; }
        if (wordBreak === void 0) { wordBreak = true; }
        if (!isString(text)) {
            return text;
        }
        if (text.length > length) {
            if (wordBreak) {
                return text.slice(0, length) + suffix;
            }
            // tslint:disable-next-line:no-bitwise
            if (!!~text.indexOf(" ", length)) {
                return text.slice(0, text.indexOf(" ", length)) + suffix;
            }
        }
        return text;
    };
    ShortenPipe.decorators = [
        { type: Pipe, args: [{ name: "shorten" },] },
    ];
    return ShortenPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var StripTagsPipe = /** @class */ (function () {
    function StripTagsPipe() {
    }
    /**
     * @param {?} text
     * @param {...?} allowedTags
     * @return {?}
     */
    StripTagsPipe.prototype.transform = /**
     * @param {?} text
     * @param {...?} allowedTags
     * @return {?}
     */
    function (text) {
        var allowedTags = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            allowedTags[_i - 1] = arguments[_i];
        }
        return allowedTags.length > 0
            ? text.replace(new RegExp("<(?!/?(" + allowedTags.join("|") + ")s*/?)[^>]+>", "g"), "")
            : text.replace(/<(?:.|\s)*?>/g, "");
    };
    StripTagsPipe.decorators = [
        { type: Pipe, args: [{ name: "stripTags" },] },
    ];
    return StripTagsPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var TrimPipe = /** @class */ (function () {
    function TrimPipe() {
    }
    /**
     * @param {?} text
     * @param {?=} chars
     * @return {?}
     */
    TrimPipe.prototype.transform = /**
     * @param {?} text
     * @param {?=} chars
     * @return {?}
     */
    function (text, chars) {
        if (chars === void 0) { chars = "\\s"; }
        return isString(text) ? text.replace(new RegExp("^[" + chars + "]+|[" + chars + "]+$", "g"), "") : text;
    };
    TrimPipe.decorators = [
        { type: Pipe, args: [{ name: "trim" },] },
    ];
    return TrimPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var UcFirstPipe = /** @class */ (function () {
    function UcFirstPipe() {
    }
    /**
     * @param {?} text
     * @return {?}
     */
    UcFirstPipe.prototype.transform = /**
     * @param {?} text
     * @return {?}
     */
    function (text) {
        return isString(text) ? text.slice(0, 1).toUpperCase() + text.slice(1) : text;
    };
    UcFirstPipe.decorators = [
        { type: Pipe, args: [{ name: "ucfirst" },] },
    ];
    return UcFirstPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var SlugifyPipe = /** @class */ (function () {
    function SlugifyPipe() {
    }
    /**
     * @param {?} str
     * @return {?}
     */
    SlugifyPipe.prototype.transform = /**
     * @param {?} str
     * @return {?}
     */
    function (str) {
        return isString(str)
            ? str
                .toLowerCase()
                .trim()
                .replace(/[^\w\-]+/g, " ")
                .replace(/\s+/g, "-")
            : str;
    };
    SlugifyPipe.decorators = [
        { type: Pipe, args: [{ name: "slugify" },] },
    ];
    return SlugifyPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var CamelizePipe = /** @class */ (function () {
    function CamelizePipe() {
    }
    /**
     * @param {?} text
     * @param {?=} chars
     * @return {?}
     */
    CamelizePipe.prototype.transform = /**
     * @param {?} text
     * @param {?=} chars
     * @return {?}
     */
    function (text, chars) {
        if (chars === void 0) { chars = "\\s"; }
        if (!isString(text)) {
            return text;
        }
        return text
            .toLowerCase()
            .split(/[-_\s]/g)
            .filter(function (v) { return !!v; })
            .map(function (word, key) {
            return !key ? word : word.slice(0, 1).toUpperCase() + word.slice(1);
        })
            .join("");
    };
    CamelizePipe.decorators = [
        { type: Pipe, args: [{ name: "camelize" },] },
    ];
    return CamelizePipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var LatinisePipe = /** @class */ (function () {
    function LatinisePipe() {
        this.latinMap = {
            Á: "A",
            Ă: "A",
            Ắ: "A",
            Ặ: "A",
            Ằ: "A",
            Ẳ: "A",
            Ẵ: "A",
            Ǎ: "A",
            Â: "A",
            Ấ: "A",
            Ậ: "A",
            Ầ: "A",
            Ẩ: "A",
            Ẫ: "A",
            Ä: "A",
            Ǟ: "A",
            Ȧ: "A",
            Ǡ: "A",
            Ạ: "A",
            Ȁ: "A",
            À: "A",
            Ả: "A",
            Ȃ: "A",
            Ā: "A",
            Ą: "A",
            Å: "A",
            Ǻ: "A",
            Ḁ: "A",
            Ⱥ: "A",
            Ã: "A",
            Ꜳ: "AA",
            Æ: "AE",
            Ǽ: "AE",
            Ǣ: "AE",
            Ꜵ: "AO",
            Ꜷ: "AU",
            Ꜹ: "AV",
            Ꜻ: "AV",
            Ꜽ: "AY",
            Ḃ: "B",
            Ḅ: "B",
            Ɓ: "B",
            Ḇ: "B",
            Ƀ: "B",
            Ƃ: "B",
            Ć: "C",
            Č: "C",
            Ç: "C",
            Ḉ: "C",
            Ĉ: "C",
            Ċ: "C",
            Ƈ: "C",
            Ȼ: "C",
            Ď: "D",
            Ḑ: "D",
            Ḓ: "D",
            Ḋ: "D",
            Ḍ: "D",
            Ɗ: "D",
            Ḏ: "D",
            ǲ: "D",
            ǅ: "D",
            Đ: "D",
            Ƌ: "D",
            Ǳ: "DZ",
            Ǆ: "DZ",
            É: "E",
            Ĕ: "E",
            Ě: "E",
            Ȩ: "E",
            Ḝ: "E",
            Ê: "E",
            Ế: "E",
            Ệ: "E",
            Ề: "E",
            Ể: "E",
            Ễ: "E",
            Ḙ: "E",
            Ë: "E",
            Ė: "E",
            Ẹ: "E",
            Ȅ: "E",
            È: "E",
            Ẻ: "E",
            Ȇ: "E",
            Ē: "E",
            Ḗ: "E",
            Ḕ: "E",
            Ę: "E",
            Ɇ: "E",
            Ẽ: "E",
            Ḛ: "E",
            Ꝫ: "ET",
            Ḟ: "F",
            Ƒ: "F",
            Ǵ: "G",
            Ğ: "G",
            Ǧ: "G",
            Ģ: "G",
            Ĝ: "G",
            Ġ: "G",
            Ɠ: "G",
            Ḡ: "G",
            Ǥ: "G",
            Ḫ: "H",
            Ȟ: "H",
            Ḩ: "H",
            Ĥ: "H",
            Ⱨ: "H",
            Ḧ: "H",
            Ḣ: "H",
            Ḥ: "H",
            Ħ: "H",
            Í: "I",
            Ĭ: "I",
            Ǐ: "I",
            Î: "I",
            Ï: "I",
            Ḯ: "I",
            İ: "I",
            Ị: "I",
            Ȉ: "I",
            Ì: "I",
            Ỉ: "I",
            Ȋ: "I",
            Ī: "I",
            Į: "I",
            Ɨ: "I",
            Ĩ: "I",
            Ḭ: "I",
            Ꝺ: "D",
            Ꝼ: "F",
            Ᵹ: "G",
            Ꞃ: "R",
            Ꞅ: "S",
            Ꞇ: "T",
            Ꝭ: "IS",
            Ĵ: "J",
            Ɉ: "J",
            Ḱ: "K",
            Ǩ: "K",
            Ķ: "K",
            Ⱪ: "K",
            Ꝃ: "K",
            Ḳ: "K",
            Ƙ: "K",
            Ḵ: "K",
            Ꝁ: "K",
            Ꝅ: "K",
            Ĺ: "L",
            Ƚ: "L",
            Ľ: "L",
            Ļ: "L",
            Ḽ: "L",
            Ḷ: "L",
            Ḹ: "L",
            Ⱡ: "L",
            Ꝉ: "L",
            Ḻ: "L",
            Ŀ: "L",
            Ɫ: "L",
            ǈ: "L",
            Ł: "L",
            Ǉ: "LJ",
            Ḿ: "M",
            Ṁ: "M",
            Ṃ: "M",
            Ɱ: "M",
            Ń: "N",
            Ň: "N",
            Ņ: "N",
            Ṋ: "N",
            Ṅ: "N",
            Ṇ: "N",
            Ǹ: "N",
            Ɲ: "N",
            Ṉ: "N",
            Ƞ: "N",
            ǋ: "N",
            Ñ: "N",
            Ǌ: "NJ",
            Ó: "O",
            Ŏ: "O",
            Ǒ: "O",
            Ô: "O",
            Ố: "O",
            Ộ: "O",
            Ồ: "O",
            Ổ: "O",
            Ỗ: "O",
            Ö: "O",
            Ȫ: "O",
            Ȯ: "O",
            Ȱ: "O",
            Ọ: "O",
            Ő: "O",
            Ȍ: "O",
            Ò: "O",
            Ỏ: "O",
            Ơ: "O",
            Ớ: "O",
            Ợ: "O",
            Ờ: "O",
            Ở: "O",
            Ỡ: "O",
            Ȏ: "O",
            Ꝋ: "O",
            Ꝍ: "O",
            Ō: "O",
            Ṓ: "O",
            Ṑ: "O",
            Ɵ: "O",
            Ǫ: "O",
            Ǭ: "O",
            Ø: "O",
            Ǿ: "O",
            Õ: "O",
            Ṍ: "O",
            Ṏ: "O",
            Ȭ: "O",
            Ƣ: "OI",
            Ꝏ: "OO",
            Ɛ: "E",
            Ɔ: "O",
            Ȣ: "OU",
            Ṕ: "P",
            Ṗ: "P",
            Ꝓ: "P",
            Ƥ: "P",
            Ꝕ: "P",
            Ᵽ: "P",
            Ꝑ: "P",
            Ꝙ: "Q",
            Ꝗ: "Q",
            Ŕ: "R",
            Ř: "R",
            Ŗ: "R",
            Ṙ: "R",
            Ṛ: "R",
            Ṝ: "R",
            Ȑ: "R",
            Ȓ: "R",
            Ṟ: "R",
            Ɍ: "R",
            Ɽ: "R",
            Ꜿ: "C",
            Ǝ: "E",
            Ś: "S",
            Ṥ: "S",
            Š: "S",
            Ṧ: "S",
            Ş: "S",
            Ŝ: "S",
            Ș: "S",
            Ṡ: "S",
            Ṣ: "S",
            Ṩ: "S",
            ẞ: "SS",
            Ť: "T",
            Ţ: "T",
            Ṱ: "T",
            Ț: "T",
            Ⱦ: "T",
            Ṫ: "T",
            Ṭ: "T",
            Ƭ: "T",
            Ṯ: "T",
            Ʈ: "T",
            Ŧ: "T",
            Ɐ: "A",
            Ꞁ: "L",
            Ɯ: "M",
            Ʌ: "V",
            Ꜩ: "TZ",
            Ú: "U",
            Ŭ: "U",
            Ǔ: "U",
            Û: "U",
            Ṷ: "U",
            Ü: "U",
            Ǘ: "U",
            Ǚ: "U",
            Ǜ: "U",
            Ǖ: "U",
            Ṳ: "U",
            Ụ: "U",
            Ű: "U",
            Ȕ: "U",
            Ù: "U",
            Ủ: "U",
            Ư: "U",
            Ứ: "U",
            Ự: "U",
            Ừ: "U",
            Ử: "U",
            Ữ: "U",
            Ȗ: "U",
            Ū: "U",
            Ṻ: "U",
            Ų: "U",
            Ů: "U",
            Ũ: "U",
            Ṹ: "U",
            Ṵ: "U",
            Ꝟ: "V",
            Ṿ: "V",
            Ʋ: "V",
            Ṽ: "V",
            Ꝡ: "VY",
            Ẃ: "W",
            Ŵ: "W",
            Ẅ: "W",
            Ẇ: "W",
            Ẉ: "W",
            Ẁ: "W",
            Ⱳ: "W",
            Ẍ: "X",
            Ẋ: "X",
            Ý: "Y",
            Ŷ: "Y",
            Ÿ: "Y",
            Ẏ: "Y",
            Ỵ: "Y",
            Ỳ: "Y",
            Ƴ: "Y",
            Ỷ: "Y",
            Ỿ: "Y",
            Ȳ: "Y",
            Ɏ: "Y",
            Ỹ: "Y",
            Ź: "Z",
            Ž: "Z",
            Ẑ: "Z",
            Ⱬ: "Z",
            Ż: "Z",
            Ẓ: "Z",
            Ȥ: "Z",
            Ẕ: "Z",
            Ƶ: "Z",
            Ĳ: "IJ",
            Œ: "OE",
            ᴀ: "A",
            ᴁ: "AE",
            ʙ: "B",
            ᴃ: "B",
            ᴄ: "C",
            ᴅ: "D",
            ᴇ: "E",
            ꜰ: "F",
            ɢ: "G",
            ʛ: "G",
            ʜ: "H",
            ɪ: "I",
            ʁ: "R",
            ᴊ: "J",
            ᴋ: "K",
            ʟ: "L",
            ᴌ: "L",
            ᴍ: "M",
            ɴ: "N",
            ᴏ: "O",
            ɶ: "OE",
            ᴐ: "O",
            ᴕ: "OU",
            ᴘ: "P",
            ʀ: "R",
            ᴎ: "N",
            ᴙ: "R",
            ꜱ: "S",
            ᴛ: "T",
            ⱻ: "E",
            ᴚ: "R",
            ᴜ: "U",
            ᴠ: "V",
            ᴡ: "W",
            ʏ: "Y",
            ᴢ: "Z",
            á: "a",
            ă: "a",
            ắ: "a",
            ặ: "a",
            ằ: "a",
            ẳ: "a",
            ẵ: "a",
            ǎ: "a",
            â: "a",
            ấ: "a",
            ậ: "a",
            ầ: "a",
            ẩ: "a",
            ẫ: "a",
            ä: "a",
            ǟ: "a",
            ȧ: "a",
            ǡ: "a",
            ạ: "a",
            ȁ: "a",
            à: "a",
            ả: "a",
            ȃ: "a",
            ā: "a",
            ą: "a",
            ᶏ: "a",
            ẚ: "a",
            å: "a",
            ǻ: "a",
            ḁ: "a",
            ⱥ: "a",
            ã: "a",
            ꜳ: "aa",
            æ: "ae",
            ǽ: "ae",
            ǣ: "ae",
            ꜵ: "ao",
            ꜷ: "au",
            ꜹ: "av",
            ꜻ: "av",
            ꜽ: "ay",
            ḃ: "b",
            ḅ: "b",
            ɓ: "b",
            ḇ: "b",
            ᵬ: "b",
            ᶀ: "b",
            ƀ: "b",
            ƃ: "b",
            ɵ: "o",
            ć: "c",
            č: "c",
            ç: "c",
            ḉ: "c",
            ĉ: "c",
            ɕ: "c",
            ċ: "c",
            ƈ: "c",
            ȼ: "c",
            ď: "d",
            ḑ: "d",
            ḓ: "d",
            ȡ: "d",
            ḋ: "d",
            ḍ: "d",
            ɗ: "d",
            ᶑ: "d",
            ḏ: "d",
            ᵭ: "d",
            ᶁ: "d",
            đ: "d",
            ɖ: "d",
            ƌ: "d",
            ı: "i",
            ȷ: "j",
            ɟ: "j",
            ʄ: "j",
            ǳ: "dz",
            ǆ: "dz",
            é: "e",
            ĕ: "e",
            ě: "e",
            ȩ: "e",
            ḝ: "e",
            ê: "e",
            ế: "e",
            ệ: "e",
            ề: "e",
            ể: "e",
            ễ: "e",
            ḙ: "e",
            ë: "e",
            ė: "e",
            ẹ: "e",
            ȅ: "e",
            è: "e",
            ẻ: "e",
            ȇ: "e",
            ē: "e",
            ḗ: "e",
            ḕ: "e",
            ⱸ: "e",
            ę: "e",
            ᶒ: "e",
            ɇ: "e",
            ẽ: "e",
            ḛ: "e",
            ꝫ: "et",
            ḟ: "f",
            ƒ: "f",
            ᵮ: "f",
            ᶂ: "f",
            ǵ: "g",
            ğ: "g",
            ǧ: "g",
            ģ: "g",
            ĝ: "g",
            ġ: "g",
            ɠ: "g",
            ḡ: "g",
            ᶃ: "g",
            ǥ: "g",
            ḫ: "h",
            ȟ: "h",
            ḩ: "h",
            ĥ: "h",
            ⱨ: "h",
            ḧ: "h",
            ḣ: "h",
            ḥ: "h",
            ɦ: "h",
            ẖ: "h",
            ħ: "h",
            ƕ: "hv",
            í: "i",
            ĭ: "i",
            ǐ: "i",
            î: "i",
            ï: "i",
            ḯ: "i",
            ị: "i",
            ȉ: "i",
            ì: "i",
            ỉ: "i",
            ȋ: "i",
            ī: "i",
            į: "i",
            ᶖ: "i",
            ɨ: "i",
            ĩ: "i",
            ḭ: "i",
            ꝺ: "d",
            ꝼ: "f",
            ᵹ: "g",
            ꞃ: "r",
            ꞅ: "s",
            ꞇ: "t",
            ꝭ: "is",
            ǰ: "j",
            ĵ: "j",
            ʝ: "j",
            ɉ: "j",
            ḱ: "k",
            ǩ: "k",
            ķ: "k",
            ⱪ: "k",
            ꝃ: "k",
            ḳ: "k",
            ƙ: "k",
            ḵ: "k",
            ᶄ: "k",
            ꝁ: "k",
            ꝅ: "k",
            ĺ: "l",
            ƚ: "l",
            ɬ: "l",
            ľ: "l",
            ļ: "l",
            ḽ: "l",
            ȴ: "l",
            ḷ: "l",
            ḹ: "l",
            ⱡ: "l",
            ꝉ: "l",
            ḻ: "l",
            ŀ: "l",
            ɫ: "l",
            ᶅ: "l",
            ɭ: "l",
            ł: "l",
            ǉ: "lj",
            ſ: "s",
            ẜ: "s",
            ẛ: "s",
            ẝ: "s",
            ḿ: "m",
            ṁ: "m",
            ṃ: "m",
            ɱ: "m",
            ᵯ: "m",
            ᶆ: "m",
            ń: "n",
            ň: "n",
            ņ: "n",
            ṋ: "n",
            ȵ: "n",
            ṅ: "n",
            ṇ: "n",
            ǹ: "n",
            ɲ: "n",
            ṉ: "n",
            ƞ: "n",
            ᵰ: "n",
            ᶇ: "n",
            ɳ: "n",
            ñ: "n",
            ǌ: "nj",
            ó: "o",
            ŏ: "o",
            ǒ: "o",
            ô: "o",
            ố: "o",
            ộ: "o",
            ồ: "o",
            ổ: "o",
            ỗ: "o",
            ö: "o",
            ȫ: "o",
            ȯ: "o",
            ȱ: "o",
            ọ: "o",
            ő: "o",
            ȍ: "o",
            ò: "o",
            ỏ: "o",
            ơ: "o",
            ớ: "o",
            ợ: "o",
            ờ: "o",
            ở: "o",
            ỡ: "o",
            ȏ: "o",
            ꝋ: "o",
            ꝍ: "o",
            ⱺ: "o",
            ō: "o",
            ṓ: "o",
            ṑ: "o",
            ǫ: "o",
            ǭ: "o",
            ø: "o",
            ǿ: "o",
            õ: "o",
            ṍ: "o",
            ṏ: "o",
            ȭ: "o",
            ƣ: "oi",
            ꝏ: "oo",
            ɛ: "e",
            ᶓ: "e",
            ɔ: "o",
            ᶗ: "o",
            ȣ: "ou",
            ṕ: "p",
            ṗ: "p",
            ꝓ: "p",
            ƥ: "p",
            ᵱ: "p",
            ᶈ: "p",
            ꝕ: "p",
            ᵽ: "p",
            ꝑ: "p",
            ꝙ: "q",
            ʠ: "q",
            ɋ: "q",
            ꝗ: "q",
            ŕ: "r",
            ř: "r",
            ŗ: "r",
            ṙ: "r",
            ṛ: "r",
            ṝ: "r",
            ȑ: "r",
            ɾ: "r",
            ᵳ: "r",
            ȓ: "r",
            ṟ: "r",
            ɼ: "r",
            ᵲ: "r",
            ᶉ: "r",
            ɍ: "r",
            ɽ: "r",
            ↄ: "c",
            ꜿ: "c",
            ɘ: "e",
            ɿ: "r",
            ś: "s",
            ṥ: "s",
            š: "s",
            ṧ: "s",
            ş: "s",
            ŝ: "s",
            ș: "s",
            ṡ: "s",
            ṣ: "s",
            ṩ: "s",
            ʂ: "s",
            ᵴ: "s",
            ᶊ: "s",
            ȿ: "s",
            ɡ: "g",
            ß: "ss",
            ᴑ: "o",
            ᴓ: "o",
            ᴝ: "u",
            ť: "t",
            ţ: "t",
            ṱ: "t",
            ț: "t",
            ȶ: "t",
            ẗ: "t",
            ⱦ: "t",
            ṫ: "t",
            ṭ: "t",
            ƭ: "t",
            ṯ: "t",
            ᵵ: "t",
            ƫ: "t",
            ʈ: "t",
            ŧ: "t",
            ᵺ: "th",
            ɐ: "a",
            ᴂ: "ae",
            ǝ: "e",
            ᵷ: "g",
            ɥ: "h",
            ʮ: "h",
            ʯ: "h",
            ᴉ: "i",
            ʞ: "k",
            ꞁ: "l",
            ɯ: "m",
            ɰ: "m",
            ᴔ: "oe",
            ɹ: "r",
            ɻ: "r",
            ɺ: "r",
            ⱹ: "r",
            ʇ: "t",
            ʌ: "v",
            ʍ: "w",
            ʎ: "y",
            ꜩ: "tz",
            ú: "u",
            ŭ: "u",
            ǔ: "u",
            û: "u",
            ṷ: "u",
            ü: "u",
            ǘ: "u",
            ǚ: "u",
            ǜ: "u",
            ǖ: "u",
            ṳ: "u",
            ụ: "u",
            ű: "u",
            ȕ: "u",
            ù: "u",
            ủ: "u",
            ư: "u",
            ứ: "u",
            ự: "u",
            ừ: "u",
            ử: "u",
            ữ: "u",
            ȗ: "u",
            ū: "u",
            ṻ: "u",
            ų: "u",
            ᶙ: "u",
            ů: "u",
            ũ: "u",
            ṹ: "u",
            ṵ: "u",
            ᵫ: "ue",
            ꝸ: "um",
            ⱴ: "v",
            ꝟ: "v",
            ṿ: "v",
            ʋ: "v",
            ᶌ: "v",
            ⱱ: "v",
            ṽ: "v",
            ꝡ: "vy",
            ẃ: "w",
            ŵ: "w",
            ẅ: "w",
            ẇ: "w",
            ẉ: "w",
            ẁ: "w",
            ⱳ: "w",
            ẘ: "w",
            ẍ: "x",
            ẋ: "x",
            ᶍ: "x",
            ý: "y",
            ŷ: "y",
            ÿ: "y",
            ẏ: "y",
            ỵ: "y",
            ỳ: "y",
            ƴ: "y",
            ỷ: "y",
            ỿ: "y",
            ȳ: "y",
            ẙ: "y",
            ɏ: "y",
            ỹ: "y",
            ź: "z",
            ž: "z",
            ẑ: "z",
            ʑ: "z",
            ⱬ: "z",
            ż: "z",
            ẓ: "z",
            ȥ: "z",
            ẕ: "z",
            ᵶ: "z",
            ᶎ: "z",
            ʐ: "z",
            ƶ: "z",
            ɀ: "z",
            ﬀ: "ff",
            ﬃ: "ffi",
            ﬄ: "ffl",
            ﬁ: "fi",
            ﬂ: "fl",
            ĳ: "ij",
            œ: "oe",
            ﬆ: "st",
            ₐ: "a",
            ₑ: "e",
            ᵢ: "i",
            ⱼ: "j",
            ₒ: "o",
            ᵣ: "r",
            ᵤ: "u",
            ᵥ: "v",
            ₓ: "x",
        };
    }
    /**
     * @param {?} text
     * @param {?=} chars
     * @return {?}
     */
    LatinisePipe.prototype.transform = /**
     * @param {?} text
     * @param {?=} chars
     * @return {?}
     */
    function (text, chars) {
        var _this = this;
        if (chars === void 0) { chars = "\\s"; }
        return isString(text)
            ? text.replace(/[^A-Za-z0-9]/g, function (key) {
                return _this.latinMap[key] || key;
            })
            : text;
    };
    LatinisePipe.decorators = [
        { type: Pipe, args: [{ name: "latinise" },] },
    ];
    return LatinisePipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var LinesPipe = /** @class */ (function () {
    function LinesPipe() {
    }
    /**
     * @param {?} text
     * @param {?=} chars
     * @return {?}
     */
    LinesPipe.prototype.transform = /**
     * @param {?} text
     * @param {?=} chars
     * @return {?}
     */
    function (text, chars) {
        if (chars === void 0) { chars = "\\s"; }
        return isString(text) ? text.replace(/\r\n/g, "\n").split("\n") : text;
    };
    LinesPipe.decorators = [
        { type: Pipe, args: [{ name: "lines" },] },
    ];
    return LinesPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var UnderscorePipe = /** @class */ (function () {
    function UnderscorePipe() {
    }
    /**
     * @param {?} text
     * @param {?=} chars
     * @return {?}
     */
    UnderscorePipe.prototype.transform = /**
     * @param {?} text
     * @param {?=} chars
     * @return {?}
     */
    function (text, chars) {
        if (chars === void 0) { chars = "\\s"; }
        return isString(text)
            ? text
                .trim()
                .replace(/\s+/g, "")
                .replace(/[A-Z]/g, function (c, k) {
                return k ? "_" + c.toLowerCase() : c.toLowerCase();
            })
            : text;
    };
    UnderscorePipe.decorators = [
        { type: Pipe, args: [{ name: "underscore" },] },
    ];
    return UnderscorePipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var MatchPipe = /** @class */ (function () {
    function MatchPipe() {
    }
    /**
     * @param {?} text
     * @param {?} pattern
     * @param {?=} flags
     * @return {?}
     */
    MatchPipe.prototype.transform = /**
     * @param {?} text
     * @param {?} pattern
     * @param {?=} flags
     * @return {?}
     */
    function (text, pattern, flags) {
        if (!isString(text)) {
            return text;
        }
        return text.match(new RegExp(pattern, flags));
    };
    MatchPipe.decorators = [
        { type: Pipe, args: [{ name: "match" },] },
    ];
    return MatchPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var TestPipe = /** @class */ (function () {
    function TestPipe() {
    }
    /**
     * @param {?} text
     * @param {?} pattern
     * @param {?=} flags
     * @return {?}
     */
    TestPipe.prototype.transform = /**
     * @param {?} text
     * @param {?} pattern
     * @param {?=} flags
     * @return {?}
     */
    function (text, pattern, flags) {
        if (!isString(text)) {
            return text;
        }
        return new RegExp(pattern, flags).test(text);
    };
    TestPipe.decorators = [
        { type: Pipe, args: [{ name: "test" },] },
    ];
    return TestPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var LeftPadPipe = /** @class */ (function () {
    function LeftPadPipe() {
    }
    /**
     * @param {?} str
     * @param {?} length
     * @param {?=} padCharacter
     * @return {?}
     */
    LeftPadPipe.prototype.transform = /**
     * @param {?} str
     * @param {?} length
     * @param {?=} padCharacter
     * @return {?}
     */
    function (str, length, padCharacter) {
        if (padCharacter === void 0) { padCharacter = " "; }
        if (!isString(str) || str.length >= length) {
            return str;
        }
        while (str.length < length) {
            str = padCharacter + str;
        }
        return str;
    };
    LeftPadPipe.decorators = [
        { type: Pipe, args: [{ name: "lpad" },] },
    ];
    return LeftPadPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var RightPadPipe = /** @class */ (function () {
    function RightPadPipe() {
    }
    /**
     * @param {?} str
     * @param {?=} length
     * @param {?=} padCharacter
     * @return {?}
     */
    RightPadPipe.prototype.transform = /**
     * @param {?} str
     * @param {?=} length
     * @param {?=} padCharacter
     * @return {?}
     */
    function (str, length, padCharacter) {
        if (length === void 0) { length = 1; }
        if (padCharacter === void 0) { padCharacter = " "; }
        if (!isString(str) || str.length >= length) {
            return str;
        }
        while (str.length < length) {
            str = str + padCharacter;
        }
        return str;
    };
    RightPadPipe.decorators = [
        { type: Pipe, args: [{ name: "rpad" },] },
    ];
    return RightPadPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var WrapPipe = /** @class */ (function () {
    function WrapPipe() {
    }
    /**
     * @param {?} str
     * @param {?=} prefix
     * @param {?=} suffix
     * @return {?}
     */
    WrapPipe.prototype.transform = /**
     * @param {?} str
     * @param {?=} prefix
     * @param {?=} suffix
     * @return {?}
     */
    function (str, prefix, suffix) {
        if (prefix === void 0) { prefix = ""; }
        if (suffix === void 0) { suffix = ""; }
        if (!isString(str)) {
            return str;
        }
        return (!!prefix && isString(prefix) ? prefix : "") + str + (!!suffix && isString(suffix) ? suffix : "");
    };
    WrapPipe.decorators = [
        { type: Pipe, args: [{ name: "wrap" },] },
    ];
    return WrapPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var /** @type {?} */ STRING_PIPES = [
    LeftTrimPipe,
    RepeatPipe,
    RightTrimPipe,
    ScanPipe,
    ShortenPipe,
    StripTagsPipe,
    TrimPipe,
    UcFirstPipe,
    UcWordsPipe,
    SlugifyPipe,
    CamelizePipe,
    LatinisePipe,
    LinesPipe,
    UnderscorePipe,
    MatchPipe,
    TestPipe,
    LeftPadPipe,
    RightPadPipe,
    WrapPipe,
];
var NgStringPipesModule = /** @class */ (function () {
    function NgStringPipesModule() {
    }
    NgStringPipesModule.decorators = [
        { type: NgModule, args: [{
                    declarations: STRING_PIPES,
                    imports: [],
                    exports: STRING_PIPES,
                },] },
    ];
    return NgStringPipesModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var MaxPipe = /** @class */ (function () {
    function MaxPipe() {
    }
    /**
     * @param {?} arr
     * @return {?}
     */
    MaxPipe.prototype.transform = /**
     * @param {?} arr
     * @return {?}
     */
    function (arr) {
        return Array.isArray(arr) ? Math.max.apply(Math, __spread(arr)) : arr;
    };
    MaxPipe.decorators = [
        { type: Pipe, args: [{ name: "max" },] },
    ];
    return MaxPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var MinPipe = /** @class */ (function () {
    function MinPipe() {
    }
    /**
     * @param {?} arr
     * @return {?}
     */
    MinPipe.prototype.transform = /**
     * @param {?} arr
     * @return {?}
     */
    function (arr) {
        return Array.isArray(arr) ? Math.min.apply(Math, __spread(arr)) : arr;
    };
    MinPipe.decorators = [
        { type: Pipe, args: [{ name: "min" },] },
    ];
    return MinPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var PercentagePipe = /** @class */ (function () {
    function PercentagePipe() {
    }
    /**
     * @param {?} num
     * @param {?=} total
     * @param {?=} floor
     * @return {?}
     */
    PercentagePipe.prototype.transform = /**
     * @param {?} num
     * @param {?=} total
     * @param {?=} floor
     * @return {?}
     */
    function (num, total, floor) {
        if (total === void 0) { total = 100; }
        if (floor === void 0) { floor = false; }
        if (isNaN(num)) {
            return num;
        }
        var /** @type {?} */ percent = (num * 100) / total;
        return floor ? Math.floor(percent) : percent;
    };
    PercentagePipe.decorators = [
        { type: Pipe, args: [{ name: "percentage" },] },
    ];
    return PercentagePipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var SumPipe = /** @class */ (function () {
    function SumPipe() {
    }
    /**
     * @param {?} arr
     * @return {?}
     */
    SumPipe.prototype.transform = /**
     * @param {?} arr
     * @return {?}
     */
    function (arr) {
        return Array.isArray(arr) ? arr.reduce(function (sum, curr) { return sum + curr; }, 0) : arr;
    };
    SumPipe.decorators = [
        { type: Pipe, args: [{ name: "sum" },] },
    ];
    return SumPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var FloorPipe = /** @class */ (function () {
    function FloorPipe() {
    }
    /**
     * @param {?} num
     * @param {?=} precision
     * @return {?}
     */
    FloorPipe.prototype.transform = /**
     * @param {?} num
     * @param {?=} precision
     * @return {?}
     */
    function (num, precision) {
        if (precision === void 0) { precision = 0; }
        if (precision <= 0) {
            return Math.floor(num);
        }
        var /** @type {?} */ tho = Math.pow(10, precision);
        return Math.floor(num * tho) / tho;
    };
    FloorPipe.decorators = [
        { type: Pipe, args: [{ name: "floor" },] },
    ];
    return FloorPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var RoundPipe = /** @class */ (function () {
    function RoundPipe() {
    }
    /**
     * @param {?} num
     * @param {?=} precision
     * @return {?}
     */
    RoundPipe.prototype.transform = /**
     * @param {?} num
     * @param {?=} precision
     * @return {?}
     */
    function (num, precision) {
        if (precision === void 0) { precision = 0; }
        return applyPrecision(num, precision);
    };
    RoundPipe.decorators = [
        { type: Pipe, args: [{ name: "round" },] },
    ];
    return RoundPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var SqrtPipe = /** @class */ (function () {
    function SqrtPipe() {
    }
    /**
     * @param {?} num
     * @return {?}
     */
    SqrtPipe.prototype.transform = /**
     * @param {?} num
     * @return {?}
     */
    function (num) {
        return !isNaN(num) ? Math.sqrt(num) : num;
    };
    SqrtPipe.decorators = [
        { type: Pipe, args: [{ name: "sqrt" },] },
    ];
    return SqrtPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var PowerPipe = /** @class */ (function () {
    function PowerPipe() {
    }
    /**
     * @param {?} num
     * @param {?=} power
     * @return {?}
     */
    PowerPipe.prototype.transform = /**
     * @param {?} num
     * @param {?=} power
     * @return {?}
     */
    function (num, power) {
        if (power === void 0) { power = 2; }
        return !isNaN(num) ? Math.pow(num, power) : num;
    };
    PowerPipe.decorators = [
        { type: Pipe, args: [{ name: "pow" },] },
    ];
    return PowerPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var CeilPipe = /** @class */ (function () {
    function CeilPipe() {
    }
    /**
     * @param {?} num
     * @param {?=} precision
     * @return {?}
     */
    CeilPipe.prototype.transform = /**
     * @param {?} num
     * @param {?=} precision
     * @return {?}
     */
    function (num, precision) {
        if (precision === void 0) { precision = 0; }
        if (precision <= 0) {
            return Math.ceil(num);
        }
        var /** @type {?} */ tho = Math.pow(10, precision);
        return Math.ceil(num * tho) / tho;
    };
    CeilPipe.decorators = [
        { type: Pipe, args: [{ name: "ceil" },] },
    ];
    return CeilPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var DegreesPipe = /** @class */ (function () {
    function DegreesPipe() {
    }
    /**
     * @param {?} radians
     * @return {?}
     */
    DegreesPipe.prototype.transform = /**
     * @param {?} radians
     * @return {?}
     */
    function (radians) {
        if (!isNumberFinite(radians)) {
            return NaN;
        }
        return (radians * 180) / Math.PI;
    };
    DegreesPipe.decorators = [
        { type: Pipe, args: [{ name: "degrees" },] },
    ];
    return DegreesPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var BytesPipe = /** @class */ (function () {
    function BytesPipe() {
        this.dictionary = [
            { max: 1024, type: "B" },
            { max: 1048576, type: "KB" },
            { max: 1073741824, type: "MB" },
            { max: 1.0995116e12, type: "GB" },
        ];
    }
    /**
     * @param {?} value
     * @param {?=} precision
     * @return {?}
     */
    BytesPipe.prototype.transform = /**
     * @param {?} value
     * @param {?=} precision
     * @return {?}
     */
    function (value, precision) {
        if (!isNumberFinite(value)) {
            return NaN;
        }
        var /** @type {?} */ format = this.dictionary.find(function (d) { return value < d.max; }) || this.dictionary[this.dictionary.length - 1];
        var /** @type {?} */ calc = value / (format.max / 1024);
        var /** @type {?} */ num = isUndefined(precision) ? calc : applyPrecision(calc, precision);
        return num + " " + format.type;
    };
    BytesPipe.decorators = [
        { type: Pipe, args: [{ name: "bytes" },] },
    ];
    return BytesPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var RadiansPipe = /** @class */ (function () {
    function RadiansPipe() {
    }
    /**
     * @param {?} degrees
     * @return {?}
     */
    RadiansPipe.prototype.transform = /**
     * @param {?} degrees
     * @return {?}
     */
    function (degrees) {
        if (!isNumberFinite(degrees)) {
            return NaN;
        }
        return (degrees * Math.PI) / 180;
    };
    RadiansPipe.decorators = [
        { type: Pipe, args: [{ name: "radians" },] },
    ];
    return RadiansPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var /** @type {?} */ MATH_PIPES = [
    MaxPipe,
    MinPipe,
    PercentagePipe,
    SumPipe,
    FloorPipe,
    RoundPipe,
    SqrtPipe,
    PowerPipe,
    CeilPipe,
    DegreesPipe,
    BytesPipe,
    RadiansPipe,
];
var NgMathPipesModule = /** @class */ (function () {
    function NgMathPipesModule() {
    }
    NgMathPipesModule.decorators = [
        { type: NgModule, args: [{
                    declarations: MATH_PIPES,
                    imports: [],
                    exports: MATH_PIPES,
                },] },
    ];
    return NgMathPipesModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var IsDefinedPipe = /** @class */ (function () {
    function IsDefinedPipe() {
    }
    /**
     * @param {?} input
     * @return {?}
     */
    IsDefinedPipe.prototype.transform = /**
     * @param {?} input
     * @return {?}
     */
    function (input) {
        return !isUndefined(input);
    };
    IsDefinedPipe.decorators = [
        { type: Pipe, args: [{ name: "isDefined" },] },
    ];
    return IsDefinedPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var IsNullPipe = /** @class */ (function () {
    function IsNullPipe() {
    }
    /**
     * @param {?} input
     * @return {?}
     */
    IsNullPipe.prototype.transform = /**
     * @param {?} input
     * @return {?}
     */
    function (input) {
        return input === null;
    };
    IsNullPipe.decorators = [
        { type: Pipe, args: [{ name: "isNull" },] },
    ];
    return IsNullPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var IsUndefinedPipe = /** @class */ (function () {
    function IsUndefinedPipe() {
    }
    /**
     * @param {?} input
     * @return {?}
     */
    IsUndefinedPipe.prototype.transform = /**
     * @param {?} input
     * @return {?}
     */
    function (input) {
        return isUndefined(input);
    };
    IsUndefinedPipe.decorators = [
        { type: Pipe, args: [{ name: "isUndefined" },] },
    ];
    return IsUndefinedPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var IsStringPipe = /** @class */ (function () {
    function IsStringPipe() {
    }
    /**
     * @param {?} input
     * @return {?}
     */
    IsStringPipe.prototype.transform = /**
     * @param {?} input
     * @return {?}
     */
    function (input) {
        return isString(input);
    };
    IsStringPipe.decorators = [
        { type: Pipe, args: [{ name: "isString" },] },
    ];
    return IsStringPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var IsFunctionPipe = /** @class */ (function () {
    function IsFunctionPipe() {
    }
    /**
     * @param {?} input
     * @return {?}
     */
    IsFunctionPipe.prototype.transform = /**
     * @param {?} input
     * @return {?}
     */
    function (input) {
        return isFunction(input);
    };
    IsFunctionPipe.decorators = [
        { type: Pipe, args: [{ name: "isFunction" },] },
    ];
    return IsFunctionPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var IsNumberPipe = /** @class */ (function () {
    function IsNumberPipe() {
    }
    /**
     * @param {?} input
     * @return {?}
     */
    IsNumberPipe.prototype.transform = /**
     * @param {?} input
     * @return {?}
     */
    function (input) {
        return isNumber(input);
    };
    IsNumberPipe.decorators = [
        { type: Pipe, args: [{ name: "isNumber" },] },
    ];
    return IsNumberPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var IsArrayPipe = /** @class */ (function () {
    function IsArrayPipe() {
    }
    /**
     * @param {?} input
     * @return {?}
     */
    IsArrayPipe.prototype.transform = /**
     * @param {?} input
     * @return {?}
     */
    function (input) {
        return Array.isArray(input);
    };
    IsArrayPipe.decorators = [
        { type: Pipe, args: [{ name: "isArray" },] },
    ];
    return IsArrayPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var IsObjectPipe = /** @class */ (function () {
    function IsObjectPipe() {
    }
    /**
     * @param {?} input
     * @return {?}
     */
    IsObjectPipe.prototype.transform = /**
     * @param {?} input
     * @return {?}
     */
    function (input) {
        return isObject(input);
    };
    IsObjectPipe.decorators = [
        { type: Pipe, args: [{ name: "isObject" },] },
    ];
    return IsObjectPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var IsGreaterEqualThanPipe = /** @class */ (function () {
    function IsGreaterEqualThanPipe() {
    }
    /**
     * @param {?} input
     * @param {?} other
     * @return {?}
     */
    IsGreaterEqualThanPipe.prototype.transform = /**
     * @param {?} input
     * @param {?} other
     * @return {?}
     */
    function (input, other) {
        return input >= other;
    };
    IsGreaterEqualThanPipe.decorators = [
        { type: Pipe, args: [{ name: "isGreaterEqualThan" },] },
    ];
    return IsGreaterEqualThanPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var IsGreaterThanPipe = /** @class */ (function () {
    function IsGreaterThanPipe() {
    }
    /**
     * @param {?} input
     * @param {?} other
     * @return {?}
     */
    IsGreaterThanPipe.prototype.transform = /**
     * @param {?} input
     * @param {?} other
     * @return {?}
     */
    function (input, other) {
        return input > other;
    };
    IsGreaterThanPipe.decorators = [
        { type: Pipe, args: [{ name: "isGreaterThan" },] },
    ];
    return IsGreaterThanPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var IsLessEqualThanPipe = /** @class */ (function () {
    function IsLessEqualThanPipe() {
    }
    /**
     * @param {?} input
     * @param {?} other
     * @return {?}
     */
    IsLessEqualThanPipe.prototype.transform = /**
     * @param {?} input
     * @param {?} other
     * @return {?}
     */
    function (input, other) {
        return input <= other;
    };
    IsLessEqualThanPipe.decorators = [
        { type: Pipe, args: [{ name: "isLessEqualThan" },] },
    ];
    return IsLessEqualThanPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var IsEqualToPipe = /** @class */ (function () {
    function IsEqualToPipe() {
    }
    /**
     * @param {?} input
     * @param {?} other
     * @return {?}
     */
    IsEqualToPipe.prototype.transform = /**
     * @param {?} input
     * @param {?} other
     * @return {?}
     */
    function (input, other) {
        // tslint:disable-next-line:triple-equals
        return input == other;
    };
    IsEqualToPipe.decorators = [
        { type: Pipe, args: [{ name: "isEqualTo" },] },
    ];
    return IsEqualToPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var IsNotEqualToPipe = /** @class */ (function () {
    function IsNotEqualToPipe() {
    }
    /**
     * @param {?} input
     * @param {?} other
     * @return {?}
     */
    IsNotEqualToPipe.prototype.transform = /**
     * @param {?} input
     * @param {?} other
     * @return {?}
     */
    function (input, other) {
        // tslint:disable-next-line:triple-equals
        return input != other;
    };
    IsNotEqualToPipe.decorators = [
        { type: Pipe, args: [{ name: "isNotEqualTo" },] },
    ];
    return IsNotEqualToPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var IsIdenticalToPipe = /** @class */ (function () {
    function IsIdenticalToPipe() {
    }
    /**
     * @param {?} input
     * @param {?} other
     * @return {?}
     */
    IsIdenticalToPipe.prototype.transform = /**
     * @param {?} input
     * @param {?} other
     * @return {?}
     */
    function (input, other) {
        return input === other;
    };
    IsIdenticalToPipe.decorators = [
        { type: Pipe, args: [{ name: "isIdenticalTo" },] },
    ];
    return IsIdenticalToPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var IsNotIdenticalToPipe = /** @class */ (function () {
    function IsNotIdenticalToPipe() {
    }
    /**
     * @param {?} input
     * @param {?} other
     * @return {?}
     */
    IsNotIdenticalToPipe.prototype.transform = /**
     * @param {?} input
     * @param {?} other
     * @return {?}
     */
    function (input, other) {
        return input !== other;
    };
    IsNotIdenticalToPipe.decorators = [
        { type: Pipe, args: [{ name: "isNotIdenticalTo" },] },
    ];
    return IsNotIdenticalToPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var IsLessThanPipe = /** @class */ (function () {
    function IsLessThanPipe() {
    }
    /**
     * @param {?} input
     * @param {?} other
     * @return {?}
     */
    IsLessThanPipe.prototype.transform = /**
     * @param {?} input
     * @param {?} other
     * @return {?}
     */
    function (input, other) {
        return input < other;
    };
    IsLessThanPipe.decorators = [
        { type: Pipe, args: [{ name: "isLessThan" },] },
    ];
    return IsLessThanPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var /** @type {?} */ BOOLEAN_PIPES = [
    IsDefinedPipe,
    IsNullPipe,
    IsUndefinedPipe,
    IsStringPipe,
    IsFunctionPipe,
    IsNumberPipe,
    IsArrayPipe,
    IsObjectPipe,
    IsGreaterEqualThanPipe,
    IsGreaterThanPipe,
    IsLessEqualThanPipe,
    IsLessEqualThanPipe,
    IsEqualToPipe,
    IsNotEqualToPipe,
    IsIdenticalToPipe,
    IsNotIdenticalToPipe,
    IsLessThanPipe,
];
var NgBooleanPipesModule = /** @class */ (function () {
    function NgBooleanPipesModule() {
    }
    NgBooleanPipesModule.decorators = [
        { type: NgModule, args: [{
                    declarations: BOOLEAN_PIPES,
                    imports: [],
                    exports: BOOLEAN_PIPES,
                },] },
    ];
    return NgBooleanPipesModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var NgPipesModule = /** @class */ (function () {
    function NgPipesModule() {
    }
    NgPipesModule.decorators = [
        { type: NgModule, args: [{
                    exports: [NgArrayPipesModule, NgStringPipesModule, NgMathPipesModule, NgBooleanPipesModule, NgObjectPipesModule],
                },] },
    ];
    return NgPipesModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

export { NgPipesModule, NgArrayPipesModule, DiffPipe, InitialPipe, FlattenPipe, IntersectionPipe, ReversePipe, TailPipe, TrurthifyPipe, UnionPipe, UniquePipe, WithoutPipe, PluckPipe, ShufflePipe, EveryPipe, SomePipe, SamplePipe, GroupByPipe, FilterByPipe, OrderByPipe, GroupByImpurePipe, FilterByImpurePipe, OrderByImpurePipe, RangePipe, NgObjectPipesModule, KeysPipe, ValuesPipe, PairsPipe, PickPipe, OmitPipe, InvertPipe, InvertByPipe, DiffObjPipe, STRING_PIPES, NgStringPipesModule, UcWordsPipe, LeftTrimPipe, RepeatPipe, RightTrimPipe, ScanPipe, ShortenPipe, StripTagsPipe, TrimPipe, UcFirstPipe, SlugifyPipe, CamelizePipe, LatinisePipe, LinesPipe, UnderscorePipe, MatchPipe, TestPipe, LeftPadPipe, RightPadPipe, WrapPipe, MATH_PIPES, NgMathPipesModule, MaxPipe, MinPipe, PercentagePipe, SumPipe, FloorPipe, RoundPipe, SqrtPipe, PowerPipe, CeilPipe, DegreesPipe, BytesPipe, BOOLEAN_PIPES, NgBooleanPipesModule, IsDefinedPipe, IsNullPipe, IsUndefinedPipe, IsStringPipe, IsFunctionPipe, IsNumberPipe, IsArrayPipe, IsObjectPipe, IsGreaterEqualThanPipe, IsGreaterThanPipe, IsLessEqualThanPipe, IsEqualToPipe, IsNotEqualToPipe, IsIdenticalToPipe, IsNotIdenticalToPipe, IsLessThanPipe, isString as ɵa, RadiansPipe as ɵb };

//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./node_modules/ngx-pipes/fesm5/ngx-pipes.js
// module id = ./node_modules/ngx-pipes/fesm5/ngx-pipes.js
// module chunks = vendor